import CustomBarChart, {BarChartInterface} from '../CustomBarChart/CustomBarChart';
import styles from './StatisticsPage.module.css';

function randomInt() {
    return Math.floor(Math.random() * 4);
}

function StatisticsPage(){
    const maxBar = 3;

    const years = Array.from({length: maxBar}, (_, index) => (2024 - maxBar + 1 + index));

    console.log(years)

    const pubYear = {
        title: 'Publicações por ano',
        rgba: '#0077BD',
        yItems: Array.from({length: maxBar}, () => randomInt()),
        xItems: years,
    } as BarChartInterface;

    const projetosYear = {
        title: 'Projetos por ano',
        rgba: '#0077BD',
        yItems: Array.from({length: maxBar}, () => randomInt()),
        xItems: years,
    } as BarChartInterface;

    const artefatoYear = {
        title: 'Artefatos Por Ano',
        rgba: '#0077BD',
        yItems: Array.from({length: maxBar}, () => randomInt()),
        xItems: years,
    } as BarChartInterface;

    const membros = ['Jose', 'Maicon', 'Francinalda', 'Jubiscleide'];

    const pubMembro = {
        title: 'Publicações por membro',
        rgba: '#002255',
        yItems: Array.from({length: maxBar}, () => randomInt()),
        xItems: membros,
    } as BarChartInterface;

    const projetosMembro = {
        title: 'Projetos por membro',
        rgba: '#002255',
        yItems: Array.from({length: maxBar}, () => randomInt()),
        xItems: membros,
    } as BarChartInterface;

    const artefatoMembro = {
        title: 'Artefatos por membro',
        rgba: '#002255',
        yItems: Array.from({length: maxBar}, () => randomInt()),
        xItems: membros,
    } as BarChartInterface;

    return <main>
        <p><div className={styles['bar-title']}>Estastísticas por Ano</div></p>
        <CustomBarChart {...projetosYear}></CustomBarChart>
        <CustomBarChart {...pubYear}></CustomBarChart>
        <CustomBarChart {...artefatoYear}></CustomBarChart>
    
        <br />

        <p><div className={styles['bar-title']}>Estatísticas por Membro</div></p>
        <CustomBarChart {...projetosMembro}></CustomBarChart>
        <CustomBarChart {...pubMembro}></CustomBarChart>
        <CustomBarChart {...artefatoMembro}></CustomBarChart>


    </main>
}

export default StatisticsPage